import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 12h3","key":"svg-0"}],["path",{"d":"M14 8h-4v8","key":"svg-1"}]]

const IconLetterFSmall = createReactComponent('outline', 'letter-f-small', 'LetterFSmall', __iconNode);

export default IconLetterFSmall;